import React from 'react';
import { Link } from 'react-router-dom';
import { Instagram, Mail } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-[#1e1919] text-white mt-24">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Brand Section */}
          <div className="col-span-1 md:col-span-1">
            <div className="flex items-center space-x-3 mb-4">
              <div className="w-10 h-10 bg-[#a8b5a0] rounded-full flex items-center justify-center">
                <span className="text-[#f7f5f2] font-bold text-lg">H</span>
              </div>
              <span className="text-xl font-bold tracking-tight">Hearthlowe</span>
            </div>
            <p className="text-[#bbb5ae] text-sm mb-4">
              Purely Crafted
            </p>
            <p className="text-[#bbb5ae] text-sm">
              Premium sourdough baking tools and guidance for beginners.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-white font-semibold mb-4">Learn</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/getting-started" className="text-[#bbb5ae] hover:text-white transition-colors text-sm">
                  Getting Started
                </Link>
              </li>
              <li>
                <Link to="/recipes" className="text-[#bbb5ae] hover:text-white transition-colors text-sm">
                  Recipes
                </Link>
              </li>
              <li>
                <Link to="/dictionary" className="text-[#bbb5ae] hover:text-white transition-colors text-sm">
                  Sourdough Dictionary
                </Link>
              </li>
              <li>
                <Link to="/troubleshooting" className="text-[#bbb5ae] hover:text-white transition-colors text-sm">
                  Troubleshooting
                </Link>
              </li>
            </ul>
          </div>

          {/* Support */}
          <div>
            <h3 className="text-white font-semibold mb-4">Support</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/care" className="text-[#bbb5ae] hover:text-white transition-colors text-sm">
                  Care Guides
                </Link>
              </li>
              <li>
                <Link to="/faq" className="text-[#bbb5ae] hover:text-white transition-colors text-sm">
                  FAQ
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-[#bbb5ae] hover:text-white transition-colors text-sm">
                  Contact Us
                </Link>
              </li>
              <li>
                <a
                  href="https://www.amazon.com/s/ref=nb_sb_ss_i_1_0?url=search-alias%3Daps&field-keywords=bread+proofing+basket+set&field-asin=B0G29RQGT9&rh=i:aps,ssx:relevance"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-[#bbb5ae] hover:text-white transition-colors text-sm inline-flex items-center"
                >
                  View on Amazon
                </a>
              </li>
            </ul>
          </div>

          {/* Connect */}
          <div>
            <h3 className="text-white font-semibold mb-4">Connect</h3>
            <div className="flex space-x-4 mb-4">
              <a
                href="https://instagram.com/hearthlowe"
                target="_blank"
                rel="noreferrer"
                className="text-[#bbb5ae] hover:text-white transition-colors"
                aria-label="Instagram"
              >
                <Instagram className="h-5 w-5" />
              </a>
              <a
                href="mailto:support@myhearthlowe.com"
                className="text-[#bbb5ae] hover:text-white transition-colors"
                aria-label="Email"
              >
                <Mail className="h-5 w-5" />
              </a>
            </div>
            <p className="text-[#bbb5ae] text-sm mb-2">
              Stay updated with new recipes and tips
            </p>
            <Link
              to="/?scroll=email-signup"
              className="inline-block text-sm text-[#a8b5a0] hover:text-white transition-colors underline"
            >
              Join our mailing list
            </Link>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-12 pt-8 border-t border-[#736c64]/30">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <p className="text-[#bbb5ae] text-sm">
              © {new Date().getFullYear()} Hearthlowe. All rights reserved.
            </p>
            <div className="flex space-x-6">
              <a href="#" className="text-[#bbb5ae] hover:text-white transition-colors text-sm">
                Privacy Policy
              </a>
              <a href="#" className="text-[#bbb5ae] hover:text-white transition-colors text-sm">
                Terms of Service
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
